import React from "react";
import "./css/sb-admin-2.css";
// import "./css/sb-admin-2.min.css";
import { Routes, Route } from "react-router-dom";
// import Signup from "./Screens/Auth/signup";
import ForgotPass  from "./Screens/Auth/forgotPassword";
import Login from "./Screens/Auth/login";
import PublicRoutes from "./Routers/publicRoutes/"
import ProtectedERoutes from "./Routers/Protected/";
import Layout from "./Routers/layout/";
import DashBoard from "./Screens/dashboard";
import FolderList from "./Screens/FolderList";
import DateWise from "./Screens/DateWise";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="" element={<ProtectedERoutes><Layout/></ProtectedERoutes>}>        
          <Route exact path="/" element={<DashBoard />} />
          <Route path="/:username" element={<FolderList/>} />
          <Route exact path="/:username/:date" element={<DateWise />} />
          <Route exact path="/:username/:date/:folderPath" element={<DateWise />} />
        </Route>
        <Route path="" element={<PublicRoutes><Layout/></PublicRoutes>}>
          <Route exact path="/login" element={<Login />} ></Route>
          {/* <Route exact path="/signup" element={<Signup />} ></Route> */}
          <Route exact path="/forgotPassword" element={<ForgotPass />} ></Route>
        </Route> 
      </Routes>
    </div>
  );
}

export default App;
